import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  selector: 'app-colaboradores-modal',
  templateUrl: './colaboradores-modal.component.html',
  styleUrls: ['./colaboradores-modal.component.css']
})
export class ColaboradoresModalComponent implements OnInit {
  Colaboradores: FormGroup;
  colaboradores: any;
  nifColaborador: any;
  codigoColaborador: any;

  constructor(public dialogRef: MatDialogRef<ColaboradoresModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, 
  private router: Router) {
    this.colaboradores = JSON.parse(sessionStorage.getItem('colaboradores'));
    this.nifColaborador = JSON.parse(sessionStorage.getItem('nifColaboradores'));
    this.codigoColaborador = JSON.parse(sessionStorage.getItem('codigoColaboradores'));
    console.log(this.colaboradores);
    this.crearFormulario();
  }

  ngOnInit(): void {
  }


  crearFormulario(): any {
    this.Colaboradores = this.fb.group({
      colaborador: new FormControl('', Validators.required),
      tipoTramite : new FormControl('', Validators.required),
      numPedido: new FormControl('')
    });
  }


  onNoClick(): void {
    this.dialogRef.close();
    this.router.navigate(['page/home']);
  }

  applyFilter(event: any) {
    const selectedOption = event;
    console.log("SelectedOption", selectedOption);
    this.dialogRef.close(selectedOption);
  }
}
